import React from 'react';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import ClientForm from './ClientForm';
import { validateProportion } from '../../utils/index';

class ClientTextField extends ClientForm {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      isValid: true,
      stateHelperText: '',
    };
    this.checkValidity = this.checkValidity.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.data !== this.props.data) {
      if (this.props.attribute === 'sms_longcode_source' && this.props.data !== undefined) {
        this.checkValidity(nextProps);
      }
      return true;
    }
    return false;
  }

  checkValidity(entry) {
    /**
     * This function checks the validity of the input based on its type and changes the helper text
     * and validity state accordingly
     * @param {Object} entry - The event object
     * @return {void}
     */
    // check if the entry type is number
    if (this.state.inputType === 'number') {
      const { value } = entry.target;
      const isANumber = !Number.isNaN(Number(value));
      if (this.state.attribute === 'proportion') {
        // check if valid decimal between 1 and 99 (for 1% - 99%)
        const isProportionValid = validateProportion(value);
        if (isProportionValid) {
          this.setState({ ...this.state, isValid: true, stateHelperText: '' });
          this.updateClientState(entry);
          this.updateFormValidity(true);
        } else {
          this.setState({ ...this.state, isValid: false, stateHelperText: this.state.attribute.includes('proportion') ? 'Must be a decimal between 0.01 and 0.99 (1% - 99%)' : 'Must be an integer between 0 and 100.' });
          this.updateFormValidity(false);
        }
        // check if the entry is an integer
      } else if (this.state.attribute === 'rank') {
        if ((isANumber && (Number(value) > 5 || Number(value) < 1))) {
          this.setState({ ...this.state, isValid: false, stateHelperText: 'Rank must be between 1 and 5' });
          this.updateFormValidity(false);
        } else {
          this.setState({ ...this.state, isValid: true, stateHelperText: '' });
          this.updateClientState(entry);
          this.updateFormValidity(true);
        }
      } else if (isANumber || value === '') {
        this.setState({ ...this.state, isValid: true, stateHelperText: '' });
        this.updateClientState(entry);
        this.updateFormValidity(true);
        // if neither, set the state to invalid
      } else {
        this.setState({ ...this.state, isValid: false, stateHelperText: 'Must be an integer.' });
        this.updateFormValidity(false);
      }
    }
    // if the entry type is text, set the state to valid for now
    this.updateClientState(entry);
  }

  render() {
    return (
      <div key={this.state.attribute} style={{ position: 'relative' }}>
        {!this.props.hideLabel && (
          <InputLabel
            disabled={this.state.isDisabled}
            variant="standard"
            htmlFor={this.state.attribute}
            required={this.state.required}
          >
            {this.state.label}
          </InputLabel>
        )}
        <TextField
          key={this.state.keyProp ? this.state.keyProp : this.state.attribute}
          error={!this.state.isValid}
          onChange={this.checkValidity}
          fullWidth
          // added prop to override the current default (false)
          disabled={this.props.isDisabled || this.state.isDisabled}
          id={this.state.attribute}
          value={this.props.data === undefined || this.props.data === null ? '' : this.props.data}
          name={this.state.attribute}
          style={{
            minWidth: this.props.customWidth ? this.props.customWidth : 200,
            maxWidth: this.props.customWidth ? this.props.customWidth : 450,
          }}
          size="small"
          slotProps={{
            htmlInput: {
              'data-testid': this.state.testingId,
              ...((this.state.type === 'number' || this.state.inputType === 'number') ? { min: 0 } : {}),
            },
            formHelperText: {
              sx: {
                position: 'absolute',
                top: '100%',
                left: 0,
                margin: 0,
                mt: '2px',
                fontSize: '0.65rem',
                lineHeight: 1.2,
                whiteSpace: 'normal',
              },
            },
          }}
          type={this.state.type}
          helperText={this.props.helperText ? this.props.helperText : this.state.stateHelperText}
          required={this.state.required}
        />
      </div>
    );
  }
}

export default ClientTextField;
